import React from 'react'
import { Component } from 'react';
import ChangePlaneJsx from './changePlane.jsx'
import axios from "axios";
import { baseURL } from "../../../../../constants/applicationConstants"
import swal from "sweetalert";
import { toast } from "react-toastify";

export default class ChangePlane extends Component {

  constructor(props) {
    super(props);
    this.state = {
      planDetail: null,
      bilingPeriod: 'Annual Billing',
      planType: 'Elite',
      isInstitutionExpet: false,
      isProcessing: false,
      termAndCondition: false
    }
  }

  componentDidMount = () => {
    const flowType = localStorage.getItem("flowType")

    const planData = JSON.parse(localStorage.getItem('planData'));
    const instituteId = JSON.parse(localStorage.getItem("masterID"));
    const expertId = JSON.parse(localStorage.getItem("expertId"));

    if (planData) {
      this.setState({
        bilingPeriod: planData.period,
        planType: planData.planType,
        isInstitutionExpet: planData.isInstitutionExpet,
        termAndCondition: planData.termAndCondition
      })
    }
    this.setState({ isProcessing: true })
    let instituteUrl = `subscriptionPlans?subscriberType=institute&instituteId=${instituteId}`
    let expertUrl = `subscriptionPlans?subscriberType=expert&expertId=${expertId}`

    axios.get(`${baseURL}/${flowType === "expert" ? expertUrl : instituteUrl}`).then(res => {
      this.setState({ planDetail: res.data.data, isProcessing: false })
    })
    let token = JSON.parse(localStorage.getItem('token'));
    if (!token) {
      this.props.history.push("/");
    }
  }

  onBilingButtonClick = (data) => {
    this.setState({ bilingPeriod: data })
  }

  onPlanTypeButtonClick = (plan) => {
    this.setState({ planType: plan })
  }

  onInstitutionExpertClick = (data) => {
    this.setState({ isInstitutionExpet: data })
  }

  onTermsAndConditionClick = (value) => {
    this.setState({ termAndCondition: value })
  }

  onNextButtonClick = () => {
    const planTypeData = this.state.planDetail?.filter(data => data.planName === this.state.planType);
    let plantypeID = '';
    let subscriptionPlanId = planTypeData?.[0]?.subscriptionPlanId;

    planTypeData?.[0].subscriptionPlanTypes?.forEach(data => {
      if (data.planType === "quarterly" && this.state.bilingPeriod === 'Quaterly Billing') {
        plantypeID = data.subscriptionPlanTypeId;
      } else if (data.planType === "annually" && this.state.bilingPeriod === 'Annual Billing') {
        plantypeID = data.subscriptionPlanTypeId;
      }
    });

    this.onViaCard(subscriptionPlanId, plantypeID);
  };


  onInvoiceButtonClick = () => {
    this.setState({ isProcessing: true });
    let flowName = localStorage.getItem('AdminFlow');
    const adminToken = localStorage.getItem('adminOldToken');

    let subscriptionPlanId = JSON.parse(localStorage.getItem("subscriptionPlanId"));
    let token = JSON.parse(localStorage.getItem("token"));
    let planTypeID = JSON.parse(localStorage.getItem("planTypeID"));

    let subURL = '';
    let instituteId;
    if (flowName === 'institute') {
      subURL = 'institute'
      instituteId = JSON.parse(localStorage.getItem("instituteId"));
    }
    else {
      subURL = 'expert'
      instituteId = JSON.parse(localStorage.getItem("expertId"));
    }

    const payload = {
      "subscriptionPlanTypeId": planTypeID,
      "tokenValidate": token,
      "subscriptionPlanPromotionId": this.state.promotionId,
      "subscriptionPlanId": subscriptionPlanId
    }

    axios.post(`${baseURL}/${subURL}/${instituteId}/subscriptionInvoice`, payload).then(res => {
      this.setState({ isProcessing: false });
      swal({
        title: "success",
        text: res.data.data.status,
        icon: "success",
      }).then(res => {
        if (res) {
          // back to institute if coming from institute //////////////////
          let comingFromInstitute = localStorage.getItem("comingFromInstitute")
          if (comingFromInstitute && comingFromInstitute) {
            // alert("from ins")
            // return
            let oldToken = localStorage.getItem("instituteExpertToken")
            localStorage.setItem("token", oldToken);
            localStorage.removeItem("instituteExpertToken");
            localStorage.removeItem("adInsExpert");
            localStorage.removeItem("instituteExpert");
            // localStorage.removeItem("AdminFlow");
            localStorage.setItem('flowName', 'institute')
            localStorage.setItem('flowType', 'institute')
            localStorage.removeItem("resumeOnBoard");

            localStorage.removeItem("expertId");
            localStorage.removeItem("description");
            localStorage.removeItem("expertData");
            localStorage.removeItem("subscriptionPlanId");
            localStorage.removeItem("planTypeID");
            localStorage.removeItem("planData");
            this.props.history.push("/dashBoard");
            localStorage.removeItem("comingFromInstitute");

          } else {
            // alert("from admin")
            // return
            localStorage.setItem("token", JSON.stringify(adminToken));
            localStorage.removeItem("adminOldToken")
            //localStorage.removeItem("loginData")
            localStorage.removeItem("expertId");
            localStorage.removeItem("description");
            localStorage.removeItem("expertData");
            localStorage.removeItem("subscriptionPlanId");
            localStorage.removeItem("planTypeID");
            localStorage.removeItem("planData");
            localStorage.removeItem("resumeOnBoard");

            this.props.history.push('./admin/opsDashboardHome')
          }

        }
      })
    }).catch((err) => {
      toast.error(err.response.data.error.message);
      this.setState({ isProcessing: false })
    })
  }

  onViaCard = (planId, typeId) => {

    this.setState({ isProcessing: true });
    let flowName = localStorage.getItem('flowName');

    let subscriptionPlanId = planId;
    let token = JSON.parse(localStorage.getItem("token"));
    let planTypeID = typeId;

    let instituteId = null;
    let expertId = null;
    const loginData = JSON.parse(localStorage.getItem('loginData'));
    if (flowName === 'institute') {
      instituteId = JSON.parse(localStorage.getItem("instituteId"));
    }
    else {
      expertId = JSON.parse(localStorage.getItem("expertId"));
    }

    const payload = {
      subscriptionPlanTypeId: planTypeID,
      tokenValidate: token,
      // subscriptionPlanPromotionId: this.state.promotionId,
      instituteId: instituteId || (loginData && loginData.instituteId),
      expertId: expertId || (loginData && loginData.expertId),
    };


    axios.post(`${baseURL}/subscriptionPlan/${subscriptionPlanId}/upgrade`, payload).then(resp => {
      this.setState({ isProcessing: false });
      swal({
        title: "succes",
        text: "Plan Successfully Upgraded.",
        icon: "success",
        allowOutsideClick: false,
        allowEscapeKey: false
      }).then(res => {
        if (res) {
          this.forceLogin()

          // window.location.href = expertId ? "expertPayment" : "myPayment"
        }
      })
    }).catch((err) => {
      toast.error(err.response.data.error.message);
      this.setState({ isProcessing: false })
    })
  }
  forceLogin = () => {

    localStorage.removeItem("token");
    localStorage.removeItem("loginAs");
    localStorage.removeItem("auth");
    localStorage.removeItem("masterID");
    localStorage.removeItem("expertId");
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("loginData");
    localStorage.removeItem("expertData");
    localStorage.removeItem("customerId");
    localStorage.removeItem("roleManager");
localStorage.removeItem("currentPlanInfo")
    localStorage.removeItem("planName");
    localStorage.removeItem("legalName");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("description");
    localStorage.removeItem("flowName");
    localStorage.removeItem("flowType");
    localStorage.removeItem("subscriptionPlanId");
    localStorage.removeItem("planTypeID");
    localStorage.removeItem("planData");
    localStorage.removeItem("flowName");
    localStorage.removeItem("flowType");
    localStorage.removeItem("verificationStatus");
    localStorage.removeItem('VerifyInstituteID');
    localStorage.removeItem('AdminFlow');
    localStorage.removeItem('VerifyExpertID');
    localStorage.removeItem("comingFrom");


    this.props.history.push("/");
    window.location.reload()
  };
  render() {
    return (
      <div>
        <ChangePlaneJsx
          bilingPeriod={this.state.bilingPeriod}
          onBilingButtonClick={this.onBilingButtonClick}
          planType={this.state.planType}
          onPlanTypeButtonClick={this.onPlanTypeButtonClick}
          isInstitutionExpet={this.state.isInstitutionExpet}
          onInstitutionExpertClick={this.onInstitutionExpertClick}
          termAndCondition={this.state.termAndCondition}
          onTermsAndConditionClick={this.onTermsAndConditionClick}
          onNextButtonClick={this.onNextButtonClick}
          planDetail={this.state.planDetail}
        />
      </div>
    )
  }
}